import React from 'react';
import classes from './ContactShapes.module.css';
import { Circle } from 'react-awesome-shapes/dist/shapes/circle';
import { CircleGrid } from 'react-awesome-shapes/dist/shapes/circlegrid';
import { Donut } from 'react-awesome-shapes/dist/shapes/donut';
// import { Polygon } from "react-awesome-shapes/dist/shapes/polygon";
import { Diamond } from 'react-awesome-shapes/dist/shapes/diamond';
// import { Cross } from "react-awesome-shapes/dist/shapes/cross";
// import { Star } from "react-awesome-shapes/dist/shapes/star";

const ContactShapes = () => {
  return (
    <>
      <div style={{ position: 'relative' }}>
        <Circle
          className={classes.circle}
          color="#e06f2399"
          size={['70px', '110px', '110px', '110px']}
          zIndex={-1}
        />
        <Circle
          className={classes.circle2}
          color="#1d97e899"
          size={['30px', '30px', '30px', '30px']}
          zIndex={-1}
        />
        <CircleGrid
          className={classes.circleGrid}
          color="#12d86599"
          size="110px"
          zIndex={-1}
        />
        <Diamond
          className={classes.diamond}
          color="#ce45f899"
          size="60px"
          zIndex={-1}
        />
        <Donut
          className={classes.donut}
          color="#a3474799"
          size="40px"
          width={['10px', '10px', '60px', '60px']}
          zIndex={-1}
        />
      </div>
    </>
  );
};

export default ContactShapes;
